import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        label: "Created Date",
        name: "dateCreated",
        options: {
          filter: true
        }
      },
      {
        label: "Download",
        name: "urlfile",
        options: {
          filter: true,
          customBodyRender: val => (
            <a href = {`${ROOT_URL}${val}`} download>
              {val}
            </a>
          )
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = (tableMeta.rowData !== undefined) ? tableMeta.rowData[0]:0
            return (
              <div>
                <Button variant="outlined" color="secondary" onClick={() => this.props.handleDelete(id)}>
                  Delete
                </Button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"File Uploads"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default CompanyList;
